var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { staticClass: "p-0 m-0", staticStyle: { display: "inline-flex" } },
    [
      _vm.revisionId ?? undefined
        ? _c(
            "b-col",
            { staticClass: "p-0 m-0" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-overlay",
                        {
                          attrs: {
                            show: _vm.consultando,
                            rounded: "sm",
                            "spinner-small": "",
                          },
                        },
                        [
                          !!_vm.urlDictamen
                            ? _c("ver-pdf-url", {
                                attrs: {
                                  url: _vm.urlDictamen,
                                  tooltip: _vm.$t(
                                    "apeironGwApp.dictamenSnp.acciones.verDictamen"
                                  ),
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.urlDictamen
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: _vm.$t(
                                        "apeironGwApp.dictamenSnp.acciones.previsualizarDictamen"
                                      ),
                                      expression:
                                        "$t('apeironGwApp.dictamenSnp.acciones.previsualizarDictamen')",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: {
                                    variant: "outline",
                                    disabled: _vm.consultando,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.previsualizarDictamen()
                                    },
                                  },
                                },
                                [
                                  !_vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: "file-pdf",
                                          variant: "primary",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: "file-earmark-arrow-down",
                                          variant: "primary",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.urlDictamen &&
                          _vm.permitirFirmar &&
                          _vm.estadoInsaculacion == "APROBADA" &&
                          _vm.estadoRevision == "REVISADA"
                            ? _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      value: _vm.$t(
                                        "apeironGwApp.dictamenSnp.acciones.firmarDictamen"
                                      ),
                                      expression:
                                        "$t('apeironGwApp.dictamenSnp.acciones.firmarDictamen')",
                                      modifiers: { hover: true },
                                    },
                                  ],
                                  attrs: {
                                    variant: "outline",
                                    disabled: _vm.consultando,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.verModalClave()
                                    },
                                  },
                                },
                                [
                                  !_vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: "person-check",
                                          variant: "primary",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.consultando
                                    ? _c("b-icon", {
                                        attrs: {
                                          icon: "file-earmark-arrow-down",
                                          variant: "primary",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("visualizador-pdf", {
                        attrs: {
                          id: "visualizador-dictamen",
                          contenidoBase64: _vm.contenidoBase64,
                          mostrar: _vm.mostrarPdf,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-modal",
                        {
                          attrs: { name: "modal-firmar", size: "md" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "modal-title",
                                fn: function () {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "apeironGwApp.dictamenSnp.mensajes.tituloFirmarDictamen"
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "modal-footer",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-3",
                                        attrs: {
                                          variant: "primary",
                                          disabled: !_vm.clave,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.firmarDictamen()
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.dictamenSnp.acciones.firmarDictamen"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "mt-3",
                                        attrs: { variant: "secondary" },
                                        on: {
                                          click: function ($event) {
                                            _vm.mostrarModalClave = false
                                          },
                                        },
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.dictamenSnp.acciones.cerrar"
                                              )
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            3952944273
                          ),
                          model: {
                            value: _vm.mostrarModalClave,
                            callback: function ($$v) {
                              _vm.mostrarModalClave = $$v
                            },
                            expression: "mostrarModalClave",
                          },
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "d-block text-center" },
                                [
                                  _c("h3", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.dictamenSnp.mensajes.detalleFirmarDictamen"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "apeironGwApp.dictamenSnp.campos.password"
                                        ),
                                        "label-for": "input-clave",
                                      },
                                    },
                                    [
                                      _c("b-form-input", {
                                        attrs: {
                                          type: _vm.tipoCampoClave,
                                          name: "input-clave",
                                        },
                                        model: {
                                          value: _vm.clave,
                                          callback: function ($$v) {
                                            _vm.clave = $$v
                                          },
                                          expression: "clave",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "text-right" },
                                [
                                  _c(
                                    "b-link",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.tipoCampoClave == "password",
                                          expression:
                                            "tipoCampoClave == 'password'",
                                        },
                                      ],
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function ($event) {
                                          _vm.tipoCampoClave = "text"
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.dictamenSnp.acciones.mostrar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-link",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.tipoCampoClave == "text",
                                          expression:
                                            "tipoCampoClave == 'text'",
                                        },
                                      ],
                                      attrs: { href: "javascript:void(0)" },
                                      on: {
                                        click: function ($event) {
                                          _vm.tipoCampoClave = "password"
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.dictamenSnp.acciones.ocultar"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }